import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate} from "react-router-dom";
import {PERSMISOS, hasPermissionTo, noTilde} from '../../helpers';
import { mostrarCajas} from '../../redux/reducers/cajasReducers';
import {AppBar, Empty, ListViewMode, SeacrhAppBar} from "../../components";
import Strings from "../../assets/strings";

import {Button, List, ListItem, ListItemText, Box, ListItemButton, FormControlLabel, Switch} from "@mui/material";
import PlusFab from "../../components/PlusFab";
import {formatPeso} from "../../helpers";
import LoadingProgress from "../../components/LoadingProgress";
import TransferenciaCajas from "./TransferenciaCajas";
import Crear from "./crear";
import {SyncAlt} from "@mui/icons-material"
import {ReactComponent as EmptySvg} from "../../assets/img/caja.svg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

export default function Cajas() {
    let navigate = useNavigate();
    let {pathname} = useLocation();
    let dispatch = useAppDispatch();
    const { list, status} = useAppSelector(state => state.cajas)
    const [searchBox, setSearchBox] = useState("");
    const [verInactivo, setVerInactivo] = useState(false);

    useEffect(() => {
        dispatch(mostrarCajas({incluirInactivos:verInactivo}));
    }, [dispatch, verInactivo]);


    const isEmpty = (!list || list.length === 0);
    const filterItems = () => {
        return list?.filter(item=> noTilde(item.descripcion).indexOf(noTilde(searchBox)) !== -1) ?? [];
    }
    return (
        <>
            <AppBar />
            <section className="contentInner" style={!isEmpty ? {maxWidth:600, margin:"0 auto"}:{}}>
                {status === "loading"  && <LoadingProgress vh/>}

                <ListViewMode pageRows={list?.length} pageTotalRows={list?.length} noView>
                    <FormControlLabel className="d-print-none"
                                      control={
                                          <Switch
                                              size={"small"}
                                              color={"secondary"}
                                              checked={verInactivo}
                                              onChange={()=>setVerInactivo(!verInactivo)}
                                          />
                                      }
                                      label={"Ver Inactivos"}
                    />

                    <SeacrhAppBar name="search" value={searchBox} onChange={(val:any)=>setSearchBox(val.target.value)}/>


                    {!isEmpty && hasPermissionTo(PERSMISOS.cajasTransferencias) &&
                        <Button  color="inherit" onClick={()=> navigate(pathname,{state:{modalTransferenciaCaja:true}})} >
                            <SyncAlt/>
                        </Button >
                    }
                </ListViewMode>
                <List >
                    {!isEmpty && filterItems().map(item =>
                        <ListItemButton
                            sx={item.inactivo? {
                                background: "#fccab7 !important"
                            }:{}}
                            key={item.id}
                            onClick={()=> {
                                // if(item.inactivo) return false;
                                navigate("/caja/" + item.id, undefined)
                            }}
                        >
                            <ListItemText>
                                <Box display="flex" justifyContent={"space-between"}>
                                    <span>{item.descripcion}</span>
                                    <span>{formatPeso(item.balance)}</span>
                                </Box>
                            </ListItemText>
                        </ListItemButton>
                    )}
                    {!!list?.length &&
                        <ListItem >
                            <ListItemText>
                                <Box display="flex" justifyContent={"space-between"}>
                                    <span>{Strings.total}:</span>
                                    <span>{formatPeso(
                                        filterItems().reduce((a, b) => a + (b.balance ?? 0), 0)
                                    )}</span>
                                </Box>
                            </ListItemText>
                        </ListItem>
                    }
                </List>
                {isEmpty && status !== "loading" &&
                <Empty Img={EmptySvg} title={Strings.aunNoTienes+" "+Strings.cajas}>
                    <p>{Strings.cajasHelpMsj}</p>
                </Empty>
                }
                <TransferenciaCajas/>

                {hasPermissionTo(PERSMISOS.cajasCrear) &&
                    <>
                        <PlusFab component={Button} onClick={()=> navigate(pathname,{state:{id:""}})} />
                        <Crear/>
                    </>
                }
            </section>
        </>
    );
}


